






















import Vue from 'vue'
import Divider from './Divider.vue'
import Step from './Step.vue'

type StepItem = { value: string; label: string }

type Props = {
  value: string
  steps: StepItem[]
}

type Methods = {
  stepOf: (value: string) => number
  isCompleted: (item: StepItem) => boolean
  isCurrent: (item: StepItem) => boolean
}

type Computed = {
  currentStep: number
}

export default Vue.extend<{}, Methods, Computed, Props>({
  components: { Step, Divider },
  name: 'XStepper',
  props: {
    value: {
      type: String,
      required: false,
    },
    steps: {
      type: Array,
      required: true,
    },
  },
  computed: {
    currentStep() {
      return this.stepOf(this.value)
    },
  },
  methods: {
    stepOf(value) {
      return this.steps.map((step) => step.value).indexOf(value)
    },
    isCompleted(item) {
      return this.stepOf(item.value) < this.currentStep
    },
    isCurrent(item) {
      return this.stepOf(item.value) === this.currentStep
    },
  },
})
